import { defineStore } from "pinia";
import NavigationState, { sidebarOptions } from "~/types/NavigationStateType";
import NavBarOption from "~/types/NavBarOptionType";
import routes from "~/constants/routes";
import { useOrgStore } from "~/store/org";

const monitorOptions = routes.filter(
  (route: any) => route.name === "Monitor",
)[0].subRoutes;
const reportsOptions = routes.filter(
  (route: any) => route.name === "Reports",
)[0].subRoutes;
const keyholeOptions: any[] = [];
const manageOptions = routes.filter((route: any) => route.name === "Manage")[0]
  .subRoutes;
const settingsOptions = routes.filter(
  (route: any) => route.name === "Settings",
)[0].subRoutes;
const socialOptions = routes.filter((route: any) => route.name === "Social")[0]
  .subRoutes;

export const useNavigationStore = defineStore("navigation", {
  state: (): NavigationState => ({
    activeSideBarOption: null,
    activeNavBarOption: null,
    activeNavBarOptions: null,
    activeGroup: "Monitor",
  }),
  actions: {
    setActiveSideBarOption(activeSideBarOption: sidebarOptions | null) {
      this.activeSideBarOption = activeSideBarOption;
    },
    setActiveNavBarOption(activeNavBarOption: number | null) {
      this.activeNavBarOption = activeNavBarOption;
    },
    setActiveNavBarOptions(activeNavBarOptions: Array<NavBarOption> | null) {
      this.activeNavBarOptions = activeNavBarOptions;
    },
    setActiveNavBarGroup(sidebarOption: sidebarOptions) {
      const optionMap = {
        Monitor: monitorOptions,
        Reports: reportsOptions,
        Keyhole: keyholeOptions,
        Manage: manageOptions,
        Settings: settingsOptions,
        Social: socialOptions,
      };

      this.activeGroup = sidebarOption;
      let options = (optionMap[sidebarOption] || []) as Array<NavBarOption>;

      // Filter sub-routes based on FMS permissions
      if (sidebarOption === "Manage") {
        const orgStore = useOrgStore();
        options = options.filter((option: any) => {
          // Filter specific manage sub-routes based on FMS features
          if (option.translationKey === "navbar.manage.targetMediaLists") {
            return orgStore.canAccessTargetMediaLists;
          }
          if (option.translationKey === "common.alerts") {
            return orgStore.canAccessAlerts;
          }
          return true; // Keep other manage routes
        });
      }

      this.activeNavBarOptions = options;

      this.activeNavBarOption =
        this.activeNavBarOptions && this.activeNavBarOptions.length > 0
          ? this.activeNavBarOptions[0].id
          : null;
    },
    setDisplay(id: number, newDisplay: boolean) {
      if (this.activeNavBarOptions) {
        const option = this.activeNavBarOptions.find(
          (option) => option.id === id,
        );
        if (option) {
          option.display = newDisplay;
        }
      }
    },
  },
});
